export default __webpack_public_path__ + "static/media/case5-logo.3436fb2a.webp";